export class v1_3_identity_request {
  public access_token: string;
  public user_name: string;
}
